export enum StatsConstants {
  FETCH_STATS_SUCCESS = "STATS_FETCH_STATS_SUCCESS",
  FETCH_STATS_SUCCESS_USE_LOCAL = "FETCH_STATS_SUCCESS_USE_LOCAL",
  FETCH_STATS_FAILURE = "STATS_FETCH_STATS_FAILURE",

  INIT_STATS = "STATS_INIT_STATS",

  POST_STATS_SUCCESS = "STATS_POST_STATS_SUCCESS",
  POST_STATS_FAILURE = "STATS_POST_STATS_FAILURE",

  UPDATE_STATS_SUCCESS = "STATS_UPDATE_STATS_SUCCESS",
  UPDATE_STATS_FAILURE = "STATS_UPDATE_STATS_FAILURE",
}
